import { Injectable } from "@angular/core";
import { environment } from 'environments/environment';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { log_output } from "../models/log";
import { DataService } from "./visualis.data.service";
import { Client } from "../models/client";
import { Observable } from 'rxjs';
import { catchError, finalize } from 'rxjs/operators';
//import { Router } from '@angular/router';
//import { DOCUMENT } from '@angular/common';
@Injectable()
export class LogService {

  // ==============================================================
  // State properties
  // ==============================================================

  constructor(
      private http: HttpClient,
      private dataService: DataService,
      //private router: Router
      ) {
    this.google_url = environment.url_google;
  }
  //variables
  google_url : string = "";
  authToken = localStorage.getItem("auth_token");
  httpOptions = {
    headers: new HttpHeaders({
      'Content-Type':  'application/json',
      'Authorization': `Bearer ${this.authToken}`,
      "Access-Control-Allow-Origin": "*",
      'Access-Control-Allow-Headers': 'Content-Type'
    })
  };
  //methods
  private get_text(proyect: string, document: string, method: string, type: string, message: string){
    return `[${Date.now().toLocaleString()}][${type}][${proyect}][${document}][${method}] ${message}`;
  }
  info(proyect: string, document: string, method: string, message: string){
    try{
      this.procces(proyect, document, method, "info", message);
    }
    catch (e){
      //console.log("catch... ", e)
    }
  }
  warning(proyect: string, document: string, method: string, message: string){
    try{
      this.procces(proyect, document, method, "warning", message);
    }
    catch (e){
      //console.log("catch... ", e)
    }
  }
  error(proyect: string, document: string, method: string, e: any){
    try{
      this.procces(proyect, document, method, "error", e);
    }
    catch (e){
      //console.log("catch... ", e)
    }
  }
  private procces(proyect: string, document: string, method: string, typee: string, message: string){
    //if(environment.showConsoleDebug == true){//mostrar log en pantalla
    let bool = false;
    //console.log("window.location.href: ", window.location.href);
    //console.log("this.router.url: ", this.router.url);
    try{
      if(bool){
        let text = this.get_text(proyect, document, method, typee, message);
      }
      else{//enviar log a google db
        let client = this.get_client();
          let log = new log_output(proyect, document, method, typee, message, client == null? "general":client.name,
          //window.location.href,//url
           "",// url vacio
          "SmartPlume");
          let url = this.google_url + "logservice-api";
          this.http.post<any>(url, log, this.httpOptions).pipe(
            catchError(this.handleError),
            finalize(()=>{})
          );
      }
    }
    catch(e){
      //console.log("catch in procces: ", e)
    }
  }
  handleError(): any {
    //console.log("handleError... ", handleError)
    //throw new Error("Method not implemented.");
  }
  private get_client(): Client{
    let client = this.dataService.getActiveClient();
    return client;
  }
}




// WEBPACK FOOTER //
// ./src/app/visualis/services/log.service.ts